import React, { Component } from 'react'
import Skills from './Skills'

class Resume extends Component {
  render() {
    return (
      <div className='resume' >
        <Skills />
      </div>
    )
  }
}

export default Resume
